import React from 'react';
import { styled } from "@mui/material";
import Typography from '@mui/material/Typography';

const StyledTypography = styled(Typography)(({ theme }) => ({
  animation: `$fadeIn 1000ms ${theme.transitions.easing.easeInOut}`,
  opacity: 1,
  transform: 'translateX(0)',
  "@keyframes fadeIn": {
    "0%": {
      opacity: 0,
      transform: 'translateX(-20px)',
    },
    "100%": {
      opacity: 1,
      transform: 'translateX(0)',
    },
  },
}));

const AnimatedText = ({ text }) => {
  return (
    <StyledTypography variant="h4" gutterBottom align="center">
      {text}
    </StyledTypography>
  );
};

export default AnimatedText;
